import { createFileRoute } from '@tanstack/react-router';
import { AdvancedSettings } from '../components/settings/AdvancedSettings';

export const Route = createFileRoute('/settings/advanced')({
  component: AdvancedSettings,
});
